module.exports = __webpack_public_path__ + "static/media/trivia.3baf5112.png";